/**
 * Design tokens Alterrego — palette sémantique complète.
 * Valeurs Alterrego par défaut ; chaque tenant overridevia theme.colors dans tenant.config.json.
 */

export const tokens = {
  color: {
    // Brand — overridés par ThemeProvider depuis config tenant
    primary: '#1464B4',
    secondary: '#2864A0',
    accent: '#E3A81F',
    // Surfaces
    surface: '#FFFFFF',
    surfaceAlt: '#F0F4F8',
    // Texte
    text: '#0F172A',
    textMuted: '#64748B',
    // Bordure
    border: '#E2E8F0',
    // Sémantique
    success: '#16A34A',
    warning: '#D97706',
    error: '#DC2626',
    info: '#1464B4',
    // Aliases historiques — ne pas utiliser dans du nouveau code
    primaryDark: '#2864A0',
    ink: '#3C3C50',
    white: '#FFFFFF',
    grey50: '#F7F8FA',
    grey100: '#EEF1F5',
    grey200: '#D8DEE6',
    grey400: '#8A93A3',
    grey600: '#4A5161',
    danger: '#DC2626',
  },
  radius: {
    sm: '6px',
    md: '12px',
    lg: '20px',
    xl: '24px',
    full: '9999px',
  },
  spacing: {
    '0': '0px',
    '1': '4px',
    '2': '8px',
    '3': '12px',
    '4': '16px',
    '6': '24px',
    '8': '32px',
    '12': '48px',
    '16': '64px',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  font: {
    family: '"DM Sans", -apple-system, system-ui, sans-serif',
    size: {
      xs: '12px',
      sm: '13px',
      base: '16px',
      md: '16px',
      lg: '20px',
      xl: '24px',
      '2xl': '28px',
      '3xl': '36px',
      xxl: '40px',
    },
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: '1.2',
      base: '1.5',
      loose: '1.8',
    },
  },
  shadow: {
    sm: '0 1px 4px rgba(0,0,0,0.08)',
    md: '0 4px 12px rgba(60,60,80,0.10)',
    lg: '0 12px 32px rgba(60,60,80,0.14)',
  },
} as const;

export type Tokens = typeof tokens;
